import api from "../index"

const blogsApi = api.injectEndpoints({
  endpoints: (build) => ({
    createBlog: build.mutation({
      query: (body) => ({
        url: `/blogs/create`,
        method: "POST",
        body,
      }),
    }),
    blogList: build.query({
      query: (params) => ({
        url: `/blogs/list`,
        method: "GET",
        params,
      }),
    }),
    blogDelete: build.mutation({
      query: ({ id }) => ({
        url: `/blogs/${id}`,
        method: "DELETE",
      }),
    }),
    getBlogById: build.query({
      query: ({ id }) => ({
        url: `/blogs/${id}`,
        method: "GET",
      }),
    }),
    editBlog: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/blogs/${id}`,
        method: "PUT",
        body: { ...rest },
      }),
    }),
  }),
})

export const {
  useCreateBlogMutation,
  useLazyBlogListQuery,
  useBlogDeleteMutation,
  useLazyGetBlogByIdQuery,
  useEditBlogMutation,
} = blogsApi
